// extracted by mini-css-extract-plugin
module.exports = {"error-text":"template_editor__error-text___3TQ0T","errorText":"template_editor__error-text___3TQ0T"};